import {
  ADD_READY_FOR_PICKUP,
  ADD_DISPATCH_DATA,
  UPDATE_DISPATCH_DATA_FETCH_INPROGRESS,
  ADD_IN_PROGRESS_DATA,
  ADD_COMPLETE_DATA,
  UPDATE_FETCH_COMPLETE_DATA_INPROGRESS,
  RECEIVE_SLIDES_DATA,
  SEND_SLIDES_DATA,
  UPDATE_FETCH_PROGRESS_DATA_INPROGRESS,
  UPDATE_READY_FOR_PICKUP_FETCH_INPROGRESS,
  UPDATE_LOGISTICS_RECEIVE_SLIDES_SUCCESS,
  UPDATE_LOGISTICS_RECEIVE_SLIDES_ERROR,
  UPDATE_LOGISTICS_SEND_SLIDES_SUCCESS,
  UPDATE_LOGISTICS_SEND_SLIDES_ERROR,
  UPDATE_LOGISTICS_RECEIVE_SLIDES_CLOSE,
  SET_ERROR_MESSAGE,
} from '../../../actions'

export const getReadyForPickupDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_READY_FOR_PICKUP:
      return { ...state, ...action.payload }
    case UPDATE_READY_FOR_PICKUP_FETCH_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getDispatchDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_DISPATCH_DATA:
      return { ...state, ...action.payload }
    case UPDATE_DISPATCH_DATA_FETCH_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getInProgressDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_IN_PROGRESS_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_PROGRESS_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getCompleteDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_COMPLETE_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_COMPLETE_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const receiveSlidesDataReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_SLIDES_DATA:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

const receiveSlide = {
  re_slide_success: false,
  re_slide_error: false,
}

export const receiveSlidesDataResponseReducer = (state = receiveSlide, action) => {
  switch (action.type) {
    case UPDATE_LOGISTICS_RECEIVE_SLIDES_SUCCESS:
      return { ...state, re_slide_success: true, re_slide_error: false }
    case UPDATE_LOGISTICS_RECEIVE_SLIDES_ERROR:
      return { ...state, re_slide_success: false, re_slide_error: true }
    case UPDATE_LOGISTICS_RECEIVE_SLIDES_CLOSE:
      return { ...state, re_slide_success: false, re_slide_error: false }
    default:
      return state
  }
}
export const errorMessageReducer = (state = '', action) => {
  switch (action.type) {
    case SET_ERROR_MESSAGE:
      return action.payload

    default:
      return state
  }
}
export const sendSlidesDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_SLIDES_DATA:
      return { ...state, ...action.payload }

    default:
      return state
  }
}

const sendSlide = {
  re_slide_success: false,
  re_slide_error: false,
}

export const sendSlidesDataResponseReducer = (state = sendSlide, action) => {
  switch (action.type) {
    case UPDATE_LOGISTICS_SEND_SLIDES_SUCCESS:
      return { ...state, re_slide_success: true, re_slide_error: false }
    case UPDATE_LOGISTICS_SEND_SLIDES_ERROR:
      return { ...state, re_slide_success: false, re_slide_error: true }

    default:
      return state
  }
}
